import React, { useEffect, useState } from 'react'
import Table from '../shared/table/Table';
import { FiEdit3} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import { fetchData } from '../../utils/options';
import { MdThumbDown, MdThumbUp } from 'react-icons/md';
import topTost from '../../utils/topTost';



const DistrictTable = () => {
  const navigate = useNavigate();

  const handleDelete = (rowId) => {
    // Your delete logic here
    console.log("Delete row with id:", rowId);
  };
  const [districtData, setDistrictData] = useState([]);

  const fetchDistrictData = async () => {
    const result = await fetchData('GetAllDistrict', {}, 'POST');
    if (result) {
      const district = result.districts;
      setDistrictData(district);
    }
  };



  const toggleStatus = async (Id) => {
    const result = await fetchData(`toggle-status-district/${Id}`, {}, 'POST');

    if (result && result.code === 200) {
      fetchDistrictData();
      if (result?.status === 1) {
        topTost({
          title: 'Status updated successfully: Active',
          icon: 'success',
        });
      } else {
        topTost({
          title: 'Status updated successfully: Deactive',
          icon: 'success',
        });
      }
    } else {
      console.error('Failed to toggle state status:', result?.message);
    }
  };


  const columns = [

    {
      accessorKey: 'actions',
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.district_id;
        const is_active = row.original.status;

        return (
          <div className="hstack gap-2 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/master/edit-district/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
           
            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },
      meta: {
        headerClassName: 'width-30', exportable: false,
      },
    },
    {
      accessorKey: 'state_title',
      header: () => 'State',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },
    {
      accessorKey: 'district_title',
      header: () => 'District',
      cell: (info) => info.getValue(),
        defaultIsVisible: true,
    },

  ]

  useEffect(() => {
    fetchDistrictData();
  }, [])
  return (
    <>
      <Table data={districtData} columns={columns} />
    </>
  )
}

export default DistrictTable